import React from 'react';
import { Alert } from 'reactstrap';
import { isProblemDetails } from '~/lib/helper/ErrorHelper';

type TransactionErrorProps = {
    heading: string;
    error: unknown;
};

export default function TransactionError({ heading, error }: TransactionErrorProps) {
    // PayPal completion/cancellation failures are server-side processing errors returned as plain
    // ProblemDetails, never 400 form-validation responses — so we render the ProblemDetails shape
    // only and intentionally don't special-case ValidationProblemDetails' field-level `errors`.
    const problemDetails = isProblemDetails(error) ? error : null;
    return (
        <div>
            <Alert color="danger">
                <h4 className="alert-heading">{heading}</h4>
                <p>We have encountered an error trying to process your request{problemDetails ? ':' : '.'}</p>
                {problemDetails && (
                    <>
                        <p>
                            <strong>{problemDetails.title}</strong>
                        </p>
                        {problemDetails.detail && <p>{problemDetails.detail}</p>}
                        {problemDetails.request_id_message && <p>{problemDetails.request_id_message}</p>}
                    </>
                )}
            </Alert>
        </div>
    );
}
